var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.879,
    height: 19.837,
    viewBox: "0 0 8.879 19.837",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "reorder",
    d: "M9.167,14.643H7.31V5.194H9.167a.926.926,0,0,0,.684-1.587L6.382.272a1,1,0,0,0-1.368,0L1.543,3.607a.926.926,0,0,0,.684,1.587H4.085v9.449H2.228a.926.926,0,0,0-.684,1.587l3.47,3.334a1,1,0,0,0,1.368,0l3.47-3.334a.926.926,0,0,0-.684-1.587Z",
    transform: "translate(-1.258 0)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReorder);
export default __webpack_public_path__ + "static/media/reorder.5f1a6e197a5cd039264ced98680ff976.svg";
export { ForwardRef as ReactComponent };